import ImageInput from './ImageInput';
import FakeImageInput from './FakeImageInput'

export { FakeImageInput };

export default ImageInput;
